module.exports = __webpack_public_path__ + "static/media/Chapter 2 Slide 2.98b1f707.jpg";